module.exports = __webpack_public_path__ + "static/media/puzzle.6c5028d1.png";